import { OrganisationHeaderWithImage } from '@percent/lemonade'
import { OrganisationPreviewProps } from './OrganisationPreview.types'
import styles from './OrganisationPreview.module.scss'

export function OrganisationPreview({ organisation }: OrganisationPreviewProps) {
  const { name, countryCode, website, logo, address, postcode } = organisation

  return (
    <div className={styles.organisationPreview} key={name} data-testid="organisation-preview">
      <OrganisationHeaderWithImage title={name} countryCode={countryCode} iconUrl={logo} website={website} />
      <span className={styles.organisationPreviewAddress} data-testid="organisation-preview-address">
        {[address, postcode].filter(Boolean).join(', ')}
      </span>
    </div>
  )
}
